import React, { useEffect, useMemo, useRef, useState } from "react";
import WeeklyUserPlanning from "../../../_helpers/components/Planning/WeeklyUserPlanning";
import MonthlyUserPlanning from "../../../_helpers/components/Planning/MonthlyUserPlanning";
import AnnualUserPlanning from "../../../_helpers/components/Planning/AnnualUserPlanning";
import MonthlyTeamPlanning from "../../../_helpers/components/Planning/MonthlyTeamPlanning";

import {
    createTimeSlot,
    destroyTimeSlot,
    applyDayModelToTimeSlots,
    getPlanning,
    getPlanningTeam,
    getHolidays,
    updateTimeSlot,
    updateTimeSlots,
} from "../../../_api/TimeSlot";
import { getDayModels } from "../../../_api/DayModel";
import { useOutletContext } from "react-router-dom";
import {
    firstDayOfWeek,
    lastDayOfWeek,
    dateToAAAAMMJJ,
    dateWithoutHour,
    intToMonth,
    getDatesOfWeek,
    floatRoundToString,
} from "../../../_helpers/functions";
import { DefaultDropdown } from "../../../_helpers/components/Forms/Dropdown";
import { InputForm } from "../../../_helpers/components/Forms/InputLabel";
import { getPlanningUsersVisibles, getPlanningTeamsVisibles } from "../../../_api/Admin";
import { Button } from "../../../_helpers/components/Button";
import { SideBar } from "../../../_helpers/components/SideBar";
import { HourTypeDropDown } from "../../../_helpers/components/Forms/HourTypeDropDown";
import { getHourTypes } from "../../../_api/HourType";
import { askValidation } from "../../../_api/Validation";
import toast from "react-hot-toast";
import {
    extractApiErrorMessage,
    runPlanningOpWithForce,
} from "../../../_helpers/planningHourLimitNotifications";
import {
    buildApplyDayModelTargets,
    buildCorrectionRowsFromDayEdit,
    buildCorrectionRowsFromDayModel,
    buildHourTypesById,
    changeToRequiresValidation,
    dayEditRequiresValidation,
    dayModelRequiresValidation,
    expectedPlanningStateForDayKey,
} from "../../../_helpers/planningValidation";
import { getTeamUsers } from "../../../_api/Team";
import { getUserCounters } from "../../../_api/Counter";
import { HourSlice } from "../../../_helpers/components/Forms/HourSlice";
import { getBadgeages } from "../../../_api/Badgeuse";

const IndividualPlanning = (props) => {
    const { defaultView } = props;
    const [user, setUser, currentApp, currentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["MAIN"]["features"];
    const canSeeOthersPlanning = features_right?.see_others_planning === true;
    const canSeeTeamPlanning = features_right?.see_team_planning === true;
    const canSeeMyChecking = features_right?.see_my_checking === true;
    const canSeeOthersChecking = features_right?.see_others_checking === true;
    const canEditReal = features_right?.edit_real === true;
    const canForceHourLimit = features_right?.force_planning_hour_limit === true;
    const [planning, setPlanning] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [view, setView] = useState(defaultView || "weekly");
    const [selectedId, setselectedId] = useState('user:' + user.id);
    const [startDate, setStartDate] = useState(firstDayOfWeek());
    const [endDate, setEndDate] = useState(lastDayOfWeek());
    const [listUsers, setListUsers] = useState([]);
    const [listTeams, setListTeams] = useState([]);
    const [comboValues, setComboValues] = useState([]);
    const [startDatePlanning, setStartDatePlanning] = useState(
        dateToAAAAMMJJ(startDate, "-")
    );
    const [endDatePlanning, setEndDatePlanning] = useState(
        dateToAAAAMMJJ(endDate, "-")
    );
    const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
    const [month, setMonth] = useState(new Date(startDate).getMonth() + 1);
    const [year, setYear] = useState(new Date(startDate).getFullYear());
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [detailsModalOpen, setDetailsModalOpen] = useState(false);
    const [hourTypeSummaryModalOpen, setHourTypeSummaryModalOpen] = useState(false);
    const [dayEditModalOpen, setDayEditModalOpen] = useState(false);
    const [applyDayModelModalOpen, setApplyDayModelModalOpen] = useState(false);
    const [dayModels, setDayModels] = useState([]);
    const [selectedDayModelId, setSelectedDayModelId] = useState("");
    const [isApplyingDayModel, setIsApplyingDayModel] = useState(false);
    const [dayEditRows, setDayEditRows] = useState([]);
    const [dayEditToDeleteIds, setDayEditToDeleteIds] = useState([]);
    const [isSavingDayEdit, setIsSavingDayEdit] = useState(false);
    const [isSavingChangeTo, setIsSavingChangeTo] = useState(false);
    const [hoursTypes, setHoursTypes] = useState([]);
    const [hourTypesById, setHourTypesById] = useState({});
    const [hourType, setHourType] = useState("");
    const [validationRemarks, setValidationRemarks] = useState("");
    const [selectedDates, setSelectedDates] = useState([]);
    const [isTeamPlanning, setIsTeamPlanning] = useState(false);
    const [planningInfoPanelOpen, setPlanningInfoPanelOpen] = useState(false);
    const [planningActionsMenuOpen, setPlanningActionsMenuOpen] = useState(false);
    const planningActionsMenuRef = useRef(null);
    const planningInfoPanelRef = useRef(null);
    const [teamUsers, setTeamUsers] = useState([]);
    const [userCounters, setUserCounters] = useState([]);
    const [userCountersLoading, setUserCountersLoading] = useState(false);
    const [holidays, setHolidays] = useState([]);
    const [badgeages, setBadgeages] = useState([]);

    const dropdownTypesPlanning = [
        { label: "Théorique", value: "THEORICAL" },
        { label: "Prévisionnel", value: "PROVISIONAL" },
        { label: "Réalisé", value: "REAL" },
        // { label: "Demandes", value: "REQUEST" },
        // { label: "Sauvegardé", value: "SAVED" },
    ];

    const dropdownAffichages = [
        { label: "Hebdomadaire", value: "weekly" },
        { label: "Mensuel", value: "monthly" },
        { label: "Annuel", value: "annual" },
    ];

    const dropdownMonths = [...new Array(12)].map((val, index) => {
        return {
            label: intToMonth(index + 1),
            value: index + 1,
        };
    });

    const selectedLabel = (() => {
        if (!selectedId) return "";
        const inUsers = listUsers.find((u) => String(u.value) === String(selectedId));
        if (inUsers?.label) return inUsers.label;
        const inTeams = listTeams.find((t) => String(t.value) === String(selectedId));
        if (inTeams?.label) return inTeams.label;
        return "";
    })();

    const printPeriodLabel = (() => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return "";
        const opts = { day: "2-digit", month: "2-digit", year: "numeric" };
        return `${start.toLocaleDateString("fr-FR", opts)} → ${end.toLocaleDateString("fr-FR", opts)}`;
    })();

    const printableFitClass = (() => {
        // Monthly team planning uses the same component as "monthly" view.
        if (isTeamPlanning) return "print-fit-monthly";
        if (view === "monthly") return "print-fit-monthly";
        if (view === "annual") return "print-fit-annual";
        return "";
    })();

    const loadPlanning = async () => {
        setIsLoading(true);
        const isTeam = selectedId.startsWith('team:');

        setIsTeamPlanning(isTeam);

        let date1 = new Date();
        let date2 = new Date();

        if (isTeam) {
            date1 = new Date(year, month - 1, 1);
            date2 = new Date(year, month, 0);
        } else {
            switch (view) {
                case "weekly":
                    date1 = isNaN(new Date(startDatePlanning))
                        ? new Date()
                        : new Date(startDatePlanning);
                    date2 = isNaN(new Date(endDatePlanning))
                        ? new Date()
                        : new Date(endDatePlanning);
                    setMonth(date1.getMonth() + 1);
                    setYear(date2.getFullYear());
                    break;
                case "monthly":
                    date1 = firstDayOfWeek(new Date(year, month - 1, 1));
                    date2 = lastDayOfWeek(new Date(year, month, 0));
                    break;
                case "annual":
                    date1 = new Date(year, 0, 1);
                    date2 = new Date(year, 12, 0);
                    break;
            }
        }

        const start = date1 < date2 ? date1 : date2;
        const end = date1 < date2 ? date2 : date1;
        setStartDate(start);
        setEndDate(end);

        await getHolidays(start.getTime() / 1000, end.getTime() / 1000).then((resp) => {
            setHolidays(resp.data);
        });

        if (isTeam) {
            setBadgeages([]);
            const teamId = selectedId.substring(5);
            await getTeamUsers(teamId).then((resp) => {
                setTeamUsers(resp.data.sort((a, b) => a.last_name == b.last_name ? (a.first_name < b.first_name ? -1 : 1) : a.last_name < b.last_name ? -1 : 1));
            });
            await getPlanningTeam(
                teamId,
                start.getTime() / 1000,
                new Date(
                    end.getFullYear(),
                    end.getMonth(),
                    end.getDate() + 1
                ).getTime() / 1000
            ).then((resp) => {
                setPlanning(resp.data);
            });
        } else {
            const usrId = selectedId.substring(5);
            let endApi = new Date(
                end.getFullYear(),
                end.getMonth(),
                end.getDate() + 1
            ).getTime() / 1000;

            // Weekly: endDate is a Sunday; avoid expanding to the next Monday in the API call.
            if (view === "weekly") {
                const endApiDate = new Date(end);
                endApiDate.setHours(23, 59, 59, 999);
                endApi = endApiDate.getTime() / 1000;
            }
            const formatLocalDateTimeForApi = (d) => {
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                const h = String(d.getHours()).padStart(2, "0");
                const min = String(d.getMinutes()).padStart(2, "0");
                const s = String(d.getSeconds()).padStart(2, "0");
                return `${y}-${m}-${day} ${h}:${min}:${s}`;
            };

            await getPlanning(
                usrId,
                start.getTime() / 1000,
                endApi
            ).then(async (resp) => {
                setPlanning(resp.data);

                if (view === "weekly" && user?.use_time_tracking === true) {
                    const targetUserId = parseInt(usrId, 10);
                    const isSelf = Number(user.id) === targetUserId;
                    const allowed = isSelf ? canSeeMyChecking : canSeeOthersChecking;
                    if (allowed && !Number.isNaN(targetUserId)) {
                        const startDay = new Date(start);
                        startDay.setHours(0, 0, 0, 0);
                        const endDay = new Date(end);
                        endDay.setHours(23, 59, 59, 999);
                        const payload = {
                            user_id: targetUserId,
                            start_date: formatLocalDateTimeForApi(startDay),
                            end_date: formatLocalDateTimeForApi(endDay),
                        };
                        if (isSelf) {
                            payload.badge_number = user.badge_number;
                        }
                        try {
                            const badgeResp = await getBadgeages(payload);
                            setBadgeages(Array.isArray(badgeResp.data) ? badgeResp.data : []);
                        } catch (e) {
                            console.log(e);
                            setBadgeages([]);
                        }
                    } else {
                        setBadgeages([]);
                    }
                } else {
                    setBadgeages([]);
                }
            }).catch((err) => {
                console.log(err);
                setBadgeages([]);
            });
        };

        setIsLoading(false);
    };

    const loadUsers = async () => {
        if (!canSeeOthersPlanning) {
            setListUsers([
                {
                    value: `user:${user.id}`,
                    label: `${user.last_name ?? ""} ${user.first_name ?? ""}`.trim(),
                    last_date_planning_real: user?.last_date_planning_real ?? null,
                },
            ]);
            return;
        }

        await getPlanningUsersVisibles(user.id).then((resp) => {
            if (!resp.data) {
                setListUsers([
                    {
                        value: `user:${user.id}`,
                        label: `${user.last_name ?? ""} ${user.first_name ?? ""}`.trim(),
                        last_date_planning_real: user?.last_date_planning_real ?? null,
                    },
                ]);
                return;
            }

            const users = resp.data.map((planningUser) => {
                return {
                    value: `user:${planningUser.id}`,
                    label: `${planningUser.last_name ?? ""} ${planningUser.first_name ?? ""}`.trim(),
                    last_date_planning_real: planningUser.last_date_planning_real ?? null,
                };
            }).sort((a, b) => a.label.localeCompare(b.label));
            setListUsers(users);
        });
    };

    const canEditPlanning = () => {
        return features_right?.edit_my_planning === true && user.id == selectedUserIdFromSelectedId ||
            features_right?.edit_others_planning === true && selectedUserIdFromSelectedId !== user.id;
    };

    const loadTeams = async () => {
        if (!canSeeTeamPlanning) {
            setListTeams([]);
            return;
        }

        await getPlanningTeamsVisibles(user.id).then((resp) => {
            const teams = resp.data.map((team) => {
                return {
                    value: 'team:' + team.id,
                    label: team.name,
                };
            }).sort((a, b) => a.label.localeCompare(b.label));
            setListTeams(teams);
        });
    };

    const loadHoursTypes = async () => {
        await getHourTypes().then((resp) => {
            const res = resp.data.map((res) => {
                return {
                    id: res.id,
                    name: res.name,
                    abbreviation: res.abbreviation,
                    created_at: new Date(res.created_at).toLocaleDateString(),
                    is_work: res.is_work,
                    is_absence: res.is_absence,
                    is_on_site: res.is_on_site,
                    is_with_validation: res.is_with_validation,
                };
            });
            const ht_work = {
                name: "Présence",
                content: res.filter((ht) => ht.is_absence !== true),
            };
            const ht_abs = {
                name: "Absence",
                content: res.filter((ht) => ht.is_absence === true),
            };

            const grouped = [ht_work, ht_abs];
            setHoursTypes(grouped);
            setHourTypesById(buildHourTypesById(grouped));
        });
    };

    const loadData = async () => {
        loadUsers();
        loadTeams();
        loadHoursTypes();
        loadPlanning();
    };

    const selectedTimeSlotsDetails = planning?.filter((pl) => selectedTimeSlots.includes(pl.id)) ?? [];
    const selectedHasRealTimeSlots = selectedTimeSlotsDetails.some((ts) => ts?.state === "REAL");

    const getTimeSlotOwnerId = (ts) => ts?.user_id ?? ts?.user?.id ?? null;

    const uniqueOwnerIds = Array.from(
        new Set(selectedTimeSlotsDetails.map(getTimeSlotOwnerId).filter(Boolean))
    );

    const canEditSelection = () => {
        if (selectedTimeSlotsDetails.length === 0) return false;
        if (uniqueOwnerIds.length === 0) return false;

        const canEditOwnersSelection = uniqueOwnerIds.every((ownerId) => {
            const isSelf = String(ownerId) === String(user.id);
            return isSelf ? features_right["edit_my_planning"] === true : features_right["edit_others_planning"] === true;
        });

        // edit_my_planning / edit_others_planning is always the first gate.
        if (!canEditOwnersSelection) return false;

        // Only then, restrict REAL edits.
        if (selectedHasRealTimeSlots && !canEditReal) return false;

        return true;
    };

    const canViewSelectionDetails = () => {
        if (selectedTimeSlotsDetails.length === 0) return false;
        if (uniqueOwnerIds.length === 0) return false;

        return uniqueOwnerIds.every((ownerId) => {
            const isSelf = String(ownerId) === String(user.id);
            return isSelf ? true : features_right["see_others_planning"] === true;
        });
    };

    const canEditOwners = (ownerIds) => {
        if (!ownerIds || ownerIds.length === 0) return false;
        return ownerIds.every((ownerId) => {
            const isSelf = String(ownerId) === String(user.id);
            return isSelf ? features_right["edit_my_planning"] === true : features_right["edit_others_planning"] === true;
        });
    };

    const parseDayKeyToDate = (dayKey) => {
        // dayKey format: YYYY-MM-DD
        const [y, m, d] = String(dayKey).split("-").map((v) => parseInt(v, 10));
        if (!y || !m || !d) return null;
        return new Date(y, m - 1, d, 0, 0, 0, 0);
    };

    const toDayKey = (dateLike) => {
        const d = dateWithoutHour(dateLike);
        return dateToAAAAMMJJ(d, "-");
    };

    const selectedDatesDayKeys = Array.from(new Set(selectedDates.map((d) => toDayKey(d))));
    const selectedTimeSlotsDayKeys = Array.from(
        new Set(selectedTimeSlotsDetails.map((ts) => toDayKey(ts.start_date)))
    );

    const selectedUserIdFromSelectedId = selectedId?.startsWith("user:") ? selectedId.substring(5) : null;

    const applyDayModelTargetDayKeys =
        selectedTimeSlotsDetails.length > 0 ? selectedTimeSlotsDayKeys : selectedDatesDayKeys;

    const applyDayModelOwnerIds =
        selectedTimeSlotsDetails.length > 0
            ? uniqueOwnerIds
            : (selectedUserIdFromSelectedId ? [selectedUserIdFromSelectedId] : []);

    const canOpenApplyDayModelModal =
        applyDayModelTargetDayKeys.length > 0 &&
        applyDayModelOwnerIds.length > 0 &&
        canEditOwners(applyDayModelOwnerIds) &&
        (selectedTimeSlotsDetails.length > 0 || !!selectedUserIdFromSelectedId) &&
        !(selectedTimeSlotsDetails.length > 0 && selectedHasRealTimeSlots && !canEditReal);

    // Priority: selected time slots' day; fallback to selected day (even if empty).
    const dayEditDayKey =
        selectedTimeSlotsDetails.length > 0
            ? (selectedTimeSlotsDayKeys.length === 1 ? selectedTimeSlotsDayKeys[0] : null)
            : (selectedDatesDayKeys.length === 1 ? selectedDatesDayKeys[0] : null);

    const dayEditOwnerIdFromSelectedId = selectedUserIdFromSelectedId;

    const dayEditOwnerIdFromSelection =
        selectedTimeSlotsDetails.length > 0 && uniqueOwnerIds.length === 1 ? uniqueOwnerIds[0] : null;

    const dayEditOwnerId =
        dayEditOwnerIdFromSelection ??
        (selectedTimeSlotsDetails.length === 0 ? dayEditOwnerIdFromSelectedId : null);

    const lastDatePlanningRealByUserId = useMemo(() => {
        const map = new Map();
        map.set(String(user.id), user?.last_date_planning_real ?? null);

        for (const listUser of listUsers ?? []) {
            const ownerId = listUser?.value?.startsWith("user:")
                ? listUser.value.substring(5)
                : listUser?.id;
            if (ownerId) {
                map.set(String(ownerId), listUser.last_date_planning_real ?? null);
            }
        }

        for (const teamUser of teamUsers ?? []) {
            if (teamUser?.id) {
                map.set(String(teamUser.id), teamUser.last_date_planning_real ?? null);
            }
        }

        for (const ts of planning ?? []) {
            const ownerId = getTimeSlotOwnerId(ts);
            if (ownerId && ts?.user?.last_date_planning_real !== undefined) {
                map.set(String(ownerId), ts.user.last_date_planning_real);
            }
        }

        return map;
    }, [user.id, user?.last_date_planning_real, listUsers, teamUsers, planning]);

    const getLastDatePlanningRealForUser = (ownerId) => {
        if (!ownerId) return null;
        return lastDatePlanningRealByUserId.get(String(ownerId)) ?? null;
    };

    const expectedStateForDayEdit = useMemo(() => {
        if (!dayEditDayKey || !dayEditOwnerId) return "PROVISIONAL";
        return expectedPlanningStateForDayKey(
            getLastDatePlanningRealForUser(dayEditOwnerId),
            dayEditDayKey
        );
    }, [dayEditDayKey, dayEditOwnerId, lastDatePlanningRealByUserId]);

    const dayEditTimeSlots = dayEditDayKey && dayEditOwnerId
        ? (planning ?? []).filter(
            (ts) =>
                toDayKey(ts.start_date) === dayEditDayKey &&
                String(getTimeSlotOwnerId(ts)) === String(dayEditOwnerId)
        )
        : [];

    const canOpenDayEditModal = () => {
        if (!dayEditDayKey) return false;
        if (!dayEditOwnerId) return false;

        // If some time slots are selected, they must all belong to the same day and a single owner.
        if (selectedTimeSlotsDetails.length > 0) {
            if (selectedTimeSlotsDayKeys.length !== 1) return false;
            if (uniqueOwnerIds.length !== 1) return false;
        } else {
            // No time slot selected: allow only if a single day is selected and we're in a user context.
            if (selectedDatesDayKeys.length !== 1) return false;
            if (!dayEditOwnerIdFromSelectedId) return false;
        }

        const ownerId = dayEditOwnerId;
        const isSelf = String(ownerId) === String(user.id);
        const canEditOwner = isSelf
            ? features_right["edit_my_planning"] === true
            : features_right["edit_others_planning"] === true;

        // edit_my_planning / edit_others_planning is always the first gate.
        if (!canEditOwner) return false;

        // Only then, restrict REAL edits.
        if (!canEditReal && dayEditTimeSlots.some((ts) => ts?.state === "REAL")) {
            return false;
        }

        return true;
    };

    const canOpenDayEdit = canOpenDayEditModal();

    const setDayEditStartTime = (value, index) => {
        setDayEditRows((prev) => {
            const row = prev[index];
            if (!row || row.locked) return prev;
            return prev.map((r, i) => (i === index ? { ...r, startTime: value } : r));
        });
    };

    const setDayEditEndTime = (value, index) => {
        setDayEditRows((prev) => {
            const row = prev[index];
            if (!row || row.locked) return prev;
            return prev.map((r, i) => (i === index ? { ...r, endTime: value } : r));
        });
    };

    const setDayEditHourType = (value, index) => {
        setDayEditRows((prev) => {
            const row = prev[index];
            if (!row || row.locked) return prev;
            return prev.map((r, i) => (i === index ? { ...r, hourTypeId: value } : r));
        });
    };

    const handleRemoveDayEditRow = (rowIndex) => {
        setDayEditRows((prev) => {
            const row = prev[rowIndex];
            if (!row) return prev;
            if (row.locked) {
                toast.error("Vous n'avez pas le droit de modifier le réalisé.");
                return prev;
            }

            if (row.tsId) {
                setDayEditToDeleteIds((ids) => [...ids, row.tsId]);
            }

            return prev.filter((_, i) => i !== rowIndex);
        });
    };

    const addDayEditRow = () => {
        if (!dayEditOwnerId || !dayEditDayKey) return;
        const first = dayEditRows[0];
        const defaultHourTypeId =
            first?.hourTypeId ??
            hoursTypes?.[0]?.content?.[0]?.id ??
            hoursTypes?.[0]?.id ??
            "";

        const defaultState = expectedStateForDayEdit;

        setDayEditRows((prev) => {
            const last = prev[prev.length - 1];
            let defaultStartTime = "09:00";
            let defaultEndTime = "10:00";

            if (last?.endTime) {
                const [hours, minutes] = last.endTime.split(":").map(Number);
                defaultStartTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
                const endDate = new Date();
                endDate.setHours(hours, minutes, 0, 0);
                endDate.setHours(endDate.getHours() + 1);
                defaultEndTime = `${String(endDate.getHours()).padStart(2, "0")}:${String(endDate.getMinutes()).padStart(2, "0")}`;
            }

            return [
                ...prev,
                {
                    tsId: null,
                    userId: dayEditOwnerId,
                    hourTypeId: defaultHourTypeId,
                    startTime: defaultStartTime,
                    endTime: defaultEndTime,
                    state: defaultState,
                    locked: defaultState === "REAL" && !canEditReal,
                },
            ];
        });
    };

    const roundToHalf = (value) => Math.round(value * 2) / 2;

    const hoursToDaysPerDay = (hours) => Math.min(1, roundToHalf(hours / 7));

    const splitHoursByDay = (timeSlot) => {
        const start = new Date(timeSlot.start_date);
        const end = new Date(timeSlot.end_date);
        if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return {};
        if (end <= start) return {};

        const result = {};
        let cursor = dateWithoutHour(start);

        while (cursor < end) {
            const dayStart = new Date(cursor);
            const dayEnd = new Date(cursor);
            dayEnd.setDate(dayEnd.getDate() + 1);

            const overlapStart = start > dayStart ? start : dayStart;
            const overlapEnd = end < dayEnd ? end : dayEnd;

            if (overlapEnd > overlapStart) {
                const hours = (overlapEnd - overlapStart) / 3600000;
                const key = dateToAAAAMMJJ(dayStart, "-");
                result[key] = (result[key] ?? 0) + hours;
            }

            cursor = dayEnd;
        }

        return result;
    };

    const aggregateItemsByHourType = (items, state) => {
        const rowsByHourTypeId = new Map();

        items
            .filter((ts) => ts.state === state)
            .forEach((ts) => {
                const hourTypeObj = ts.hour_type;
                const hourTypeId = ts.hour_type_id ?? hourTypeObj?.id;
                if (!hourTypeId) return;

                const existing = rowsByHourTypeId.get(hourTypeId) ?? {
                    hourTypeId,
                    hourType: hourTypeObj,
                    isWork: hourTypeObj?.is_work === true,
                    totalHours: 0,
                    hoursByDay: {},
                };

                const byDay = splitHoursByDay(ts);
                Object.entries(byDay).forEach(([dayKey, hours]) => {
                    existing.hoursByDay[dayKey] = (existing.hoursByDay[dayKey] ?? 0) + hours;
                    existing.totalHours += hours;
                });

                rowsByHourTypeId.set(hourTypeId, existing);
            });

        const rows = Array.from(rowsByHourTypeId.values()).map((row) => {
            const totalDays = Object.values(row.hoursByDay).reduce(
                (acc, hours) => acc + hoursToDaysPerDay(hours),
                0
            );
            return { ...row, totalDays };
        });

        rows.sort((a, b) => (a.hourType?.name ?? "").localeCompare(b.hourType?.name ?? ""));

        const totals = rows.reduce(
            (acc, row) => {
                if (row.isWork) {
                    acc.workedHours += row.totalHours;
                    acc.workedDays += row.totalDays;
                } else {
                    acc.nonWorkedHours += row.totalHours;
                    acc.nonWorkedDays += row.totalDays;
                }
                return acc;
            },
            { workedHours: 0, workedDays: 0, nonWorkedHours: 0, nonWorkedDays: 0 }
        );

        return { rows, totals };
    };

    const planningDetails = planning ?? [];
    const panelProvisionalAgg = aggregateItemsByHourType(planningDetails, "PROVISIONAL");
    const panelRealAgg = aggregateItemsByHourType(planningDetails, "REAL");
    const mergedPanelByHourType = (() => {
        const rowsById = new Map();

        const appendRows = (rows, stateKey) => {
            rows.forEach((row) => {
                const existing = rowsById.get(row.hourTypeId) ?? {
                    hourTypeId: row.hourTypeId,
                    hourType: row.hourType,
                    isWork: row.isWork,
                    provisionalHours: 0,
                    provisionalDays: 0,
                    realHours: 0,
                    realDays: 0,
                };

                if (stateKey === "PROVISIONAL") {
                    existing.provisionalHours += row.totalHours;
                    existing.provisionalDays += row.totalDays;
                } else {
                    existing.realHours += row.totalHours;
                    existing.realDays += row.totalDays;
                }

                rowsById.set(row.hourTypeId, existing);
            });
        };

        appendRows(panelProvisionalAgg.rows, "PROVISIONAL");
        appendRows(panelRealAgg.rows, "REAL");

        const rows = Array.from(rowsById.values()).map((row) => ({
            ...row,
            totalHours: row.provisionalHours + row.realHours,
            totalDays: row.provisionalDays + row.realDays,
        }));

        rows.sort((a, b) => (a.hourType?.name ?? "").localeCompare(b.hourType?.name ?? ""));
        return rows;
    })();

    const mergedPanelTotals = mergedPanelByHourType.reduce(
        (acc, row) => {
            if (row.isWork) {
                acc.workedHours += row.totalHours;
                acc.workedDays += row.totalDays;
            } else {
                acc.nonWorkedHours += row.totalHours;
                acc.nonWorkedDays += row.totalDays;
            }
            return acc;
        },
        { workedHours: 0, workedDays: 0, nonWorkedHours: 0, nonWorkedDays: 0 }
    );

    const formatCounterValue = (rawValue, rawType) => {
        const type = `${rawType ?? ""}`.toUpperCase();
        const value = Number.parseFloat(rawValue);
        if (!Number.isFinite(value)) return "-";

        if (type === "DAYS") {
            return `${floatRoundToString(value, 3)}j`;
        }

        if (type === "HOURS") {
            const sign = value < 0 ? "-" : "";
            const abs = Math.abs(value);
            const totalMinutes = Math.round(abs * 60);
            const h = Math.floor(totalMinutes / 60);
            const m = totalMinutes % 60;
            return m === 0 ? `${sign}${h}h` : `${sign}${h}h${String(m).padStart(2, "0")}`;
        }

        return floatRoundToString(value, 3);
    };

    const selectionCountLabel = `${selectedTimeSlotsDetails.length} créneau${selectedTimeSlotsDetails.length > 1 ? "x" : ""} sélectionné${selectedTimeSlotsDetails.length > 1 ? "s" : ""}`;

    const renderSelectedTimeSlotLabel = (ts) => {
        const start = new Date(ts.start_date);
        const end = new Date(ts.end_date);
        const hourTypeName = ts.hour_type?.name || "N/A";
        const dateLabel = start.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
        const timeLabel = (date) =>
            date.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
            });
        const startTime = timeLabel(start);
        const endTime = timeLabel(end);

        if (start.toDateString() !== end.toDateString()) {
            const endDateLabel = end.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
            return (
                <>
                    <span className="font-semibold">{hourTypeName}</span>
                    {` du ${dateLabel} de ${startTime} au ${endDateLabel} à ${endTime}`}
                </>
            );
        }

        return (
            <>
                <span className="font-semibold">{hourTypeName}</span>
                {` le ${dateLabel} de ${startTime} à ${endTime}`}
            </>
        );
    };

    const renderSelectionCards = () => (
        <div className="space-y-4">
            <div className="text-sm font-semibold text-gray-700 border-b border-gray-200 pb-2">
                {selectionCountLabel}
            </div>
            {selectedTimeSlotsDetails.map((ts) => {
                return (
                    <div key={ts.id} className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
                        <div className="text-sm text-gray-900">{renderSelectedTimeSlotLabel(ts)}</div>
                        {ts.created_at ? (
                            <div className="mt-1 text-xs text-gray-500">
                                Créé le{" "}
                                {new Date(ts.created_at).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })}
                            </div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );

    const renderMergedHourTypeSummary = () => (
        <div className="space-y-3">
            <div className="flex items-center justify-between gap-3">
                <div className="text-sm font-semibold text-gray-900 hover:underline cursor-pointer" onClick={() => setHourTypeSummaryModalOpen(true)}>Synthèse par type d'heure</div>
            </div>
            {mergedPanelByHourType.length === 0 ? (
                <div className="text-sm text-gray-500">Aucun créneau.</div>
            ) : (
                <div className="space-y-2">
                    {mergedPanelByHourType.map((row) => (
                        <div key={row.hourTypeId} className="flex items-center justify-between gap-3 text-sm">
                            <div className="min-w-0">
                                <div className="truncate font-medium text-gray-900">{row.hourType?.name ?? "Type d'heure"}</div>
                            </div>
                            <div className="text-right shrink-0 font-semibold text-gray-900">
                                {floatRoundToString(row.totalHours)}h • {floatRoundToString(row.totalDays)}j
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    const renderUserCountersSidebar = () => (
        <div className="space-y-3">
            <div className="text-sm font-semibold text-gray-900">Solde compteurs</div>
            {userCountersLoading ? (
                <div className="text-sm text-gray-500">Chargement…</div>
            ) : userCounters.length === 0 ? (
                <div className="text-sm text-gray-500">Aucun compteur.</div>
            ) : (
                <div className="space-y-1">
                    {userCounters.map((counter) => (
                        <div
                            key={counter.id}
                            className="flex items-center justify-between gap-2 rounded-md border border-gray-200 px-2 py-1.5 text-sm"
                        >
                            <span className="min-w-0 truncate font-medium text-gray-900">
                                {counter.name}
                            </span>
                            <span className="shrink-0 font-semibold tabular-nums text-gray-900">
                                {formatCounterValue(counter.total_mvt, counter.type)}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    const renderMergedHourTypeSummaryPrint = () => (
        <div className="space-y-2">
            <div className="text-sm font-semibold text-gray-900">Synthèse par type d'heure</div>
            {mergedPanelByHourType.length === 0 ? (
                <div className="text-sm text-gray-500">Aucun créneau.</div>
            ) : (
                <div className="space-y-2">
                    <div className="grid grid-cols-3 gap-1.5">
                        {mergedPanelByHourType.map((row) => (
                            <div
                                key={row.hourTypeId}
                                className="rounded-md border border-gray-200 px-2 py-1 text-[12px]"
                            >
                                <div className="flex items-start justify-between gap-2">
                                    <div className="min-w-0">
                                        <div className="truncate font-medium text-gray-900">
                                            {row.hourType?.name ?? "Type d'heure"}
                                        </div>
                                    </div>
                                    <div className="shrink-0 text-right font-semibold text-gray-900 tabular-nums whitespace-nowrap">
                                        {floatRoundToString(row.totalHours)}h • {floatRoundToString(row.totalDays)}j
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );

    const renderUserCountersPrint = () => (
        <div className="space-y-2">
            <div className="text-sm font-semibold text-gray-900">Solde compteurs</div>
            {userCountersLoading ? (
                <div className="text-sm text-gray-500">Chargement…</div>
            ) : userCounters.length === 0 ? (
                <div className="text-sm text-gray-500">Aucun compteur.</div>
            ) : (
                <div className="grid grid-cols-3 gap-1.5">
                    {userCounters.map((counter) => (
                        <div
                            key={counter.id}
                            className="flex items-center justify-between gap-2 rounded-md border border-gray-200 px-2 py-1 text-[12px]"
                        >
                            <span className="min-w-0 truncate font-medium text-gray-900">
                                {counter.name}
                            </span>
                            <span className="shrink-0 font-semibold tabular-nums text-gray-900">
                                {formatCounterValue(counter.total_mvt, counter.type)}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    const formatDayKeyShort = (dayKey) => {
        // dayKey: "YYYY-MM-DD"
        const [y, m, d] = String(dayKey).split("-").map((v) => parseInt(v, 10));
        if (!y || !m || !d) return dayKey;
        const date = new Date(y, m - 1, d);
        return date.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" });
    };

    const formatDayKeyLong = (dayKey) => {
        const [y, m, d] = String(dayKey).split("-").map((v) => parseInt(v, 10));
        if (!y || !m || !d) return dayKey;
        const date = new Date(y, m - 1, d);
        return date.toLocaleDateString("fr-FR", { weekday: "long", day: "2-digit", month: "2-digit" });
    };

    const teamHeadcountEntries = isTeamPlanning
        ? (() => {
            const byDay = new Map(); // dayKey -> Set<ownerId>

            planningDetails
                .filter((ts) => ["PROVISIONAL", "REAL"].includes(ts.state))
                .filter((ts) => ts.hour_type?.is_work === true)
                .forEach((ts) => {
                    const ownerId = getTimeSlotOwnerId(ts);
                    if (!ownerId) return;

                    const byDayHours = splitHoursByDay(ts);
                    Object.entries(byDayHours).forEach(([dayKey, hours]) => {
                        if (!(hours > 0)) return;
                        if (!byDay.has(dayKey)) byDay.set(dayKey, new Set());
                        byDay.get(dayKey).add(String(ownerId));
                    });
                });

            return Array.from(byDay.entries())
                .map(([dayKey, owners]) => ({ dayKey, count: owners.size }))
                .sort((a, b) => a.dayKey.localeCompare(b.dayKey));
        })()
        : [];

    const teamHeadcountByDayKey = teamHeadcountEntries.reduce((acc, e) => {
        acc[e.dayKey] = e.count;
        return acc;
    }, {});

    const renderTeamHeadcountPanel = () => {
        const countByDayKey = new Map(teamHeadcountEntries.map((e) => [e.dayKey, e.count]));

        const start = new Date(startDate);
        const end = new Date(endDate);
        if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
            return (
                <div className="space-y-3">
                    <div className="text-sm font-semibold text-gray-900">Effectif par jour (travaillé)</div>
                    <div className="text-sm text-gray-500">Période invalide.</div>
                </div>
            );
        }

        const startDay = new Date(start);
        startDay.setHours(0, 0, 0, 0);
        const endDay = new Date(end);
        endDay.setHours(0, 0, 0, 0);

        const startOfWeekMonday = (dateLike) => {
            const d = new Date(dateLike);
            d.setHours(0, 0, 0, 0);
            const mondayOffset = (d.getDay() + 6) % 7; // Mon=0 ... Sun=6
            d.setDate(d.getDate() - mondayOffset);
            return d;
        };

        const firstMonday = startOfWeekMonday(startDay);
        const lastMonday = startOfWeekMonday(endDay);

        const weeks = [];
        for (let monday = new Date(firstMonday); monday <= lastMonday; monday.setDate(monday.getDate() + 7)) {
            const weekDates = getDatesOfWeek(monday); // Mon..Sun
            weeks.push({ monday: new Date(monday), weekDates });
        }

        return (
            <div className="space-y-3">
                <div className="text-sm font-semibold text-gray-900">Effectif par jour (travaillé)</div>
                {weeks.length === 0 ? (
                    <div className="text-sm text-gray-500">Aucune donnée.</div>
                ) : (
                    <div className="space-y-3">
                        {weeks.map((w) => {
                            const weekKey = toDayKey(w.monday);
                            return (
                                <div key={weekKey} className="rounded-md border border-gray-200 overflow-hidden">
                                    <div className="p-2 overflow-x-auto">
                                        <table className="w-full table-fixed border-separate border-spacing-1">
                                            <tbody>
                                                <tr>
                                                    {w.weekDates.map((d) => {
                                                        const dayKey = toDayKey(d);
                                                        const inPeriod =
                                                            dateWithoutHour(d).getTime() >= startDay.getTime() &&
                                                            dateWithoutHour(d).getTime() <= endDay.getTime();
                                                        return (
                                                            <td key={dayKey} className="text-[11px] text-gray-700 text-center whitespace-nowrap">
                                                                {inPeriod ? formatDayKeyShort(dayKey) : ""}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                                <tr>
                                                    {w.weekDates.map((d) => {
                                                        const dayKey = toDayKey(d);
                                                        const inPeriod =
                                                            dateWithoutHour(d).getTime() >= startDay.getTime() &&
                                                            dateWithoutHour(d).getTime() <= endDay.getTime();
                                                        const count = inPeriod ? (countByDayKey.get(dayKey) ?? 0) : "";
                                                        return (
                                                            <td key={dayKey} className="text-sm font-semibold text-gray-900 text-center whitespace-nowrap">
                                                                {count}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    };

    const renderTeamHeadcountPanelPrint = () => {
        const countByDayKey = new Map(teamHeadcountEntries.map((e) => [e.dayKey, e.count]));

        const start = new Date(startDate);
        const end = new Date(endDate);
        if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
            return (
                <div className="space-y-2">
                    <div className="text-sm font-semibold text-gray-900">Effectif par jour (travaillé)</div>
                    <div className="text-sm text-gray-500">Période invalide.</div>
                </div>
            );
        }

        const startDay = new Date(start);
        startDay.setHours(0, 0, 0, 0);
        const endDay = new Date(end);
        endDay.setHours(0, 0, 0, 0);

        const days = [];
        for (let d = new Date(startDay); d <= endDay; d.setDate(d.getDate() + 1)) {
            const dayKey = toDayKey(d);
            days.push({
                dayKey,
                label: formatDayKeyShort(dayKey),
                count: countByDayKey.get(dayKey) ?? 0,
            });
        }

        return (
            <div className="space-y-2">
                <div className="text-sm font-semibold text-gray-900">Effectif par jour (travaillé)</div>
                {days.length === 0 ? (
                    <div className="text-sm text-gray-500">Aucune donnée.</div>
                ) : (
                    <div className="flex flex-wrap gap-x-3 gap-y-1 text-[12px] text-gray-900">
                        {days.map((d) => (
                            <div key={d.dayKey} className="whitespace-nowrap">
                                <span className="text-gray-700">{d.label}</span>
                                <span className="mx-1 text-gray-400">:</span>
                                <span className="font-semibold tabular-nums">{d.count}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    function handleClickWeek(dateSelected, ctrlKey) {
        const dayNumber =
            new Date(dateSelected).getDay() === 0
                ? 0
                : 7 - new Date(dateSelected).getDay();
        const aSunday = new Date(dateSelected).setDate(
            new Date(dateSelected).getDate() + dayNumber
        );
        const datesOfWeek = getDatesOfWeek(dateSelected);

        const selectedPlanning =
            planning &&
            planning.filter((pl) => {
                return (
                    dateWithoutHour(pl.start_date).getTime() >=
                    dateWithoutHour(dateSelected).getTime() &&
                    dateWithoutHour(pl.start_date).getTime() <=
                    dateWithoutHour(aSunday).getTime()
                );
            });
        const tsId = selectedPlanning.map((pl) => {
            return pl.id;
        });
        if (ctrlKey) {
            setSelectedTimeSlots([...selectedTimeSlots, ...tsId]);
            setSelectedDates([...selectedDates, ...datesOfWeek]);
        } else {
            setSelectedTimeSlots(tsId);
            setSelectedDates(datesOfWeek);
        }
    }

    function handleClickDate(dateSelected, ctrlKey) {
        const selectedPlanning =
            planning &&
            planning.filter((pl) => {
                return (
                    dateWithoutHour(pl.start_date).toDateString() ==
                    dateWithoutHour(dateSelected).toDateString()
                );
            });
        const tsId = selectedPlanning.map((pl) => {
            return pl.id;
        });
        if (ctrlKey) {
            setSelectedTimeSlots([...selectedTimeSlots, ...tsId]);
            setSelectedDates([...selectedDates, dateSelected]);
        } else {
            setSelectedTimeSlots(tsId);
            setSelectedDates([dateSelected]);
        }
    }

    function handleClickTimeSlots(tsId, ctrlKey) {
        if (ctrlKey) {
            const timeslots = tsId.reduce((acc, id) => {
                if (acc.includes(id)) {
                    // On enlève l'ID s'il est déjà sélectionné
                    return acc.filter((idSelected) => idSelected !== id);
                } else {
                    // On l'ajoute sinon
                    return [...acc, id];
                }
            }, selectedTimeSlots);
            setSelectedTimeSlots(timeslots);
        } else {
            setSelectedTimeSlots(tsId);
        }
    }

    useEffect(() => {
        // Sécurise le choix actuel si les droits ne permettent pas l'accès aux autres utilisateurs / équipes.
        setselectedId((prev) => {
            if (!prev) return prev;

            if (prev.startsWith("team:") && !canSeeTeamPlanning) {
                return `user:${user.id}`;
            }

            if (prev.startsWith("user:")) {
                const prevUserId = prev.substring(5);
                if (!canSeeOthersPlanning && String(prevUserId) !== String(user.id)) {
                    return `user:${user.id}`;
                }
            }

            return prev;
        });
    }, [canSeeOthersPlanning, canSeeTeamPlanning, user.id]);

    // useEffect(() => {
    //     loadData();
    // }, []);

    useEffect(() => {
        loadData();
    }, [canSeeOthersPlanning, canSeeTeamPlanning]);

    useEffect(() => {
        setComboValues(listTeams.length > 0 ? [{ 'group': 'Individuel', 'content': listUsers }, { 'group': 'Equipe', 'content': listTeams }] : listUsers);
    }, [listUsers, listTeams]);

    useEffect(() => {
        setEditModalOpen(false);
        setDetailsModalOpen(false);
        setHourTypeSummaryModalOpen(false);
        setDayEditModalOpen(false);
        setApplyDayModelModalOpen(false);
        setDayEditRows([]);
        setDayEditToDeleteIds([]);
        const isValidStart = !isNaN(new Date(startDatePlanning));
        const isValidEnd = !isNaN(new Date(endDatePlanning));

        if (isValidStart && isValidEnd) {
            loadPlanning();
        }
    }, [startDatePlanning, endDatePlanning, month, year]);

    useEffect(() => {
        setSelectedTimeSlots([]);
        setSelectedDates([]);
        setPlanningInfoPanelOpen(false);
        setPlanningActionsMenuOpen(false);
        setDetailsModalOpen(false);
        setHourTypeSummaryModalOpen(false);
        setDayEditModalOpen(false);
        setApplyDayModelModalOpen(false);
        setDayEditRows([]);
        setDayEditToDeleteIds([]);
        loadPlanning();
    }, [selectedId, view]);

    useEffect(() => {
        if (selectedTimeSlotsDetails.length === 0) {
            setPlanningActionsMenuOpen(false);
            setEditModalOpen(false);
            setDetailsModalOpen(false);
            setDayEditModalOpen(false);
            setApplyDayModelModalOpen(false);
            setDayEditRows([]);
            setDayEditToDeleteIds([]);
            return;
        }

        setHourType(selectedTimeSlotsDetails[0]?.hour_type_id ?? "");
    }, [selectedTimeSlots]);

    useEffect(() => {
        if (!planningActionsMenuOpen) return;

        const onPointerDown = (e) => {
            const node = planningActionsMenuRef.current;
            if (!node) return;
            if (node.contains(e.target)) return;
            setPlanningActionsMenuOpen(false);
        };

        const onKeyDown = (e) => {
            if (e.key === "Escape") {
                setPlanningActionsMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", onPointerDown);
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("mousedown", onPointerDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [planningActionsMenuOpen]);

    useEffect(() => {
        if (!planningInfoPanelOpen) return;

        const onPointerDown = (e) => {
            const node = planningInfoPanelRef.current;
            if (!node) return;
            if (node.contains(e.target)) return;
            setPlanningInfoPanelOpen(false);
        };

        const onKeyDown = (e) => {
            if (e.key === "Escape") {
                setPlanningInfoPanelOpen(false);
            }
        };

        document.addEventListener("mousedown", onPointerDown);
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("mousedown", onPointerDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [planningInfoPanelOpen]);

    useEffect(() => {
        if (!dayEditModalOpen) return;

        if (!canOpenDayEdit) {
            setDayEditModalOpen(false);
            setDayEditRows([]);
            setDayEditToDeleteIds([]);
        }
    }, [dayEditModalOpen, canOpenDayEdit]);

    useEffect(() => {
        if (!applyDayModelModalOpen) return;

        if (!canOpenApplyDayModelModal) {
            setApplyDayModelModalOpen(false);
        }
    }, [applyDayModelModalOpen, canOpenApplyDayModelModal]);

    useEffect(() => {
        if (selectedId?.startsWith("team:")) {
            setUserCounters([]);
            setUserCountersLoading(false);
            return;
        }

        const userId = selectedId?.startsWith("user:") ? selectedId.substring(5) : null;
        if (!userId) {
            setUserCounters([]);
            setUserCountersLoading(false);
            return;
        }

        let cancelled = false;
        setUserCountersLoading(true);

        getUserCounters(userId)
            .then((resp) => {
                if (!cancelled) {
                    setUserCounters(resp.data ?? []);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    toast.error("Erreur lors du chargement des compteurs.");
                    setUserCounters([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setUserCountersLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [selectedId, planning]);

    const openApplyDayModelModal = async () => {
        if (!canOpenApplyDayModelModal) return;

        try {
            const models =
                dayModels.length > 0
                    ? dayModels
                    : ((await getDayModels()).data ?? []);

            if (dayModels.length === 0) {
                setDayModels(models);
            }

            if (!selectedDayModelId && models.length > 0) {
                setSelectedDayModelId(String(models[0].id));
            }

            setApplyDayModelModalOpen(true);
        } catch (e) {
            toast.error("Impossible de charger les modèles de journée.");
        }
    };

    const canSeePlanningActionsMenu =
        features_right?.edit_my_planning === true || features_right?.edit_others_planning === true;

    const menuRightPanel = () => {
        return null;
    };

    const changeToNeedsValidation = useMemo(
        () => changeToRequiresValidation(hourType, hourTypesById),
        [hourType, hourTypesById]
    );

    const dayEditNeedsValidation = useMemo(() => {
        const planningById = new Map((planning ?? []).map((ts) => [String(ts.id), ts]));
        return dayEditRequiresValidation({
            rows: dayEditRows,
            deletedIds: dayEditToDeleteIds,
            planningById,
            hourTypesById,
        });
    }, [planning, dayEditRows, dayEditToDeleteIds, hourTypesById]);

    const renderValidationRemarksField = (visible) => {
        if (!visible) return null;
        return (
            <div className="rounded-md border border-amber-200 bg-amber-50 p-3 space-y-2">
                <div className="text-sm text-amber-900">
                    Ce type d&apos;heure nécessite une validation. La modification sera soumise pour approbation.
                </div>
                <InputForm
                    name="Commentaire"
                    type="textarea"
                    required={true}
                    value={validationRemarks}
                    set={setValidationRemarks}
                />
            </div>
        );
    };

    const handleSaveChangeTo = async () => {
        if (!canEditSelection()) {
            toast.error("Vous n'avez pas le droit de modifier ces créneaux.");
            return;
        }

        if (changeToNeedsValidation) {
            if (uniqueOwnerIds.length !== 1) {
                toast.error("La validation n'est pas disponible pour une sélection multi-salariés.");
                return;
            }
            if (!validationRemarks.trim()) {
                toast.error("Veuillez renseigner un commentaire.");
                return;
            }

            const dayKeys = selectedTimeSlotsDetails
                .map((ts) => toDayKey(ts.start_date))
                .sort();
            const startDate = dayKeys[0];
            const endDate = dayKeys[dayKeys.length - 1];

            try {
                setIsSavingChangeTo(true);
                const resp = await askValidation({
                    hour_type_id: hourType,
                    remarks: validationRemarks.trim(),
                    start_date: startDate,
                    end_date: endDate,
                    timeslot_ids: selectedTimeSlotsDetails.map((res) => res.id),
                    user_id: parseInt(uniqueOwnerIds[0], 10),
                });
                toast.success(resp.data?.message ?? "Demande de validation créée.");
                await loadPlanning();
                setSelectedTimeSlots([]);
                setValidationRemarks("");
                setEditModalOpen(false);
            } catch (e) {
                const data = e?.response?.data;
                toast.error(extractApiErrorMessage(data, "Une erreur est survenue."));
            } finally {
                setIsSavingChangeTo(false);
            }
            return;
        }

        setIsSavingChangeTo(true);
        const payload = {
            ids: selectedTimeSlotsDetails.map((res) => res.id),
            hour_type_id: hourType,
        };
        runPlanningOpWithForce(
            (force) => updateTimeSlots({ ...payload, force }),
            canForceHourLimit
        )
            .then((resp) => {
                resp.data.message.forEach((element) => {
                    if (element.statusCode == 201) {
                        toast.success(element.message);
                    } else {
                        toast.error(element.message);
                    }
                });
                loadPlanning();
                setSelectedTimeSlots([]);
                setEditModalOpen(false);
            })
            .catch((e) => {
                const data = e?.response?.data;
                if (!data?.violations?.length) {
                    toast.error(
                        extractApiErrorMessage(
                            data,
                            "Une erreur est survenue."
                        )
                    );
                }
            })
            .finally(() => {
                setIsSavingChangeTo(false);
            });
    };

    const editModalContent = (
        <div className="space-y-6">
            <div>
                <div className="mb-4 flex gap-2">
                    <div className="flex-1">
                        <HourTypeDropDown
                            nameHourType={"Type d'heure"}
                            listHourTypes={hoursTypes}
                            valueHourType={hourType}
                            setHourType={setHourType}
                        />
                    </div>
                    <div className="flex items-end">
                        <Button
                            isVisible={canEditPlanning()}
                            action={handleSaveChangeTo}
                            loading={isSavingChangeTo}
                            name={
                                <div className="flex items-center space-x-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M12 20h9" />
                                        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                                    </svg>
                                    <span>Enregistrer</span>
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
            {renderValidationRemarksField(changeToNeedsValidation)}
            {renderSelectionCards()}
        </div>
    );

    const detailsModalContent = (
        <div className="space-y-6">
            {renderSelectionCards()}
        </div>
    );

    const hourTypeSummaryModalContent = (
        <div className="space-y-4">
            {mergedPanelByHourType.length === 0 ? (
                <div className="text-sm text-gray-500">Aucun créneau sur la période.</div>
            ) : (
                <>
                    <div className="rounded-md border border-gray-200 p-3 bg-gray-50">
                        <div className="text-sm font-semibold text-gray-900">Cumul</div>
                        <div className="mt-2 space-y-1 text-sm">
                            <div className="flex items-center justify-between gap-3">
                                <div className="text-gray-700">Compté dans le temps de travail</div>
                                <div className="shrink-0 font-semibold text-gray-900 tabular-nums">
                                    {floatRoundToString(mergedPanelTotals.workedHours)}h • {floatRoundToString(mergedPanelTotals.workedDays)}j
                                </div>
                            </div>
                            <div className="flex items-center justify-between gap-3">
                                <div className="text-gray-700">Non-compté dans le temps de travail</div>
                                <div className="shrink-0 font-semibold text-gray-900 tabular-nums">
                                    {floatRoundToString(mergedPanelTotals.nonWorkedHours)}h • {floatRoundToString(mergedPanelTotals.nonWorkedDays)}j
                                </div>
                            </div>
                        </div>
                    </div>

                    {mergedPanelByHourType.map((row) => (
                        <div key={row.hourTypeId} className="rounded-md border border-gray-200 p-3">
                            <div className="flex items-center justify-between gap-3">
                                <div className="font-semibold text-gray-900">{row.hourType?.name ?? "Type d'heure"}</div>
                                <div className="text-sm font-semibold text-gray-900">
                                    Total: {floatRoundToString(row.totalHours)}h • {floatRoundToString(row.totalDays)}j
                                </div>
                            </div>
                            <div className="mt-2 text-sm text-gray-700 flex items-center justify-between">
                                <span>Prévisionnel</span>
                                <span className="font-medium">{floatRoundToString(row.provisionalHours)}h • {floatRoundToString(row.provisionalDays)}j</span>
                            </div>
                            <div className="mt-1 text-sm text-gray-700 flex items-center justify-between">
                                <span>Réalisé</span>
                                <span className="font-medium">{floatRoundToString(row.realHours)}h • {floatRoundToString(row.realDays)}j</span>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );

    const handleSaveDayEdit = async () => {
        try {
            if (!dayEditOwnerId || !dayEditDayKey) return;
            if (dayEditRows.length === 0 && dayEditToDeleteIds.length === 0) {
                toast.error("Aucune modification à enregistrer.");
                return;
            }

            if (!canOpenDayEditModal()) {
                toast.error("Vous n'avez pas le droit de modifier cette journée.");
                return;
            }

            if (!canEditReal) {
                const planningById = new Map((planning ?? []).map((ts) => [String(ts.id), ts]));
                const isDeletingReal = dayEditToDeleteIds.some((id) => planningById.get(String(id))?.state === "REAL");
                const isEditingReal = dayEditRows.some((row) => row?.locked === true);
                const isCreatingReal = dayEditRows.some((row) => !row?.tsId && row?.state === "REAL");

                if (isDeletingReal || isCreatingReal || isEditingReal) {
                    // Editing existing REAL is prevented in UI, but we hard-block as a safety net.
                    toast.error("Vous n'avez pas le droit de modifier le réalisé.");
                    return;
                }
            }

            const baseDayDate = parseDayKeyToDate(dayEditDayKey);
            if (!baseDayDate) {
                toast.error("Date invalide pour la journée.");
                return;
            }

            const toTimestampSeconds = (hhmm, dayOffset = 0) => {
                if (!hhmm || typeof hhmm !== "string") return null;
                const [h, m] = hhmm.split(":").map((v) => parseInt(v, 10));
                if (Number.isNaN(h) || Number.isNaN(m)) return null;
                return new Date(
                    baseDayDate.getFullYear(),
                    baseDayDate.getMonth(),
                    baseDayDate.getDate() + dayOffset,
                    h,
                    m,
                    0,
                    0
                ).getTime() / 1000;
            };

            const validateRowTimes = (row) => {
                const startSeconds = toTimestampSeconds(row.startTime);
                let endSeconds = toTimestampSeconds(row.endTime);
                if (startSeconds === null || endSeconds === null) return null;

                // If end <= start, consider end on the next day (J+1).
                if (endSeconds <= startSeconds) {
                    endSeconds = toTimestampSeconds(row.endTime, 1);
                    if (endSeconds === null) return null;
                }

                if (endSeconds <= startSeconds) return null;
                return { startSeconds, endSeconds };
            };

            const validatedRows = [];
            for (const row of dayEditRows) {
                if (!row.hourTypeId) {
                    toast.error("Type d'heure manquant pour un créneau.");
                    return;
                }
                const validated = validateRowTimes(row);
                if (!validated) {
                    toast.error("Horaires invalides.");
                    return;
                }
                validatedRows.push({ row, ...validated });
            }

            // Ensure no overlaps (touching is allowed).
            const intervals = validatedRows
                .map((v) => ({ startSeconds: v.startSeconds, endSeconds: v.endSeconds }))
                .sort((a, b) => a.startSeconds - b.startSeconds);

            for (let i = 1; i < intervals.length; i += 1) {
                if (intervals[i].startSeconds < intervals[i - 1].endSeconds) {
                    toast.error("Chevauchement détecté entre des créneaux.");
                    return;
                }
            }

            setIsSavingDayEdit(true);

            if (dayEditNeedsValidation) {
                if (!validationRemarks.trim()) {
                    toast.error("Veuillez renseigner un commentaire.");
                    return;
                }

                const resp = await askValidation({
                    hour_type_id: null,
                    day: dayEditDayKey,
                    remarks: validationRemarks.trim(),
                    rows: buildCorrectionRowsFromDayEdit(dayEditRows),
                    user_id: parseInt(dayEditOwnerId, 10),
                });

                toast.success(resp.data?.message ?? "Demande de validation créée.");
                await loadPlanning();
                setSelectedTimeSlots([]);
                setSelectedDates([]);
                setDayEditToDeleteIds([]);
                setDayEditRows([]);
                setValidationRemarks("");
                setDayEditModalOpen(false);
                return;
            }

            const deletePromises = dayEditToDeleteIds.map((tsId) =>
                runPlanningOpWithForce(
                    (force) => destroyTimeSlot(tsId, { force }),
                    canForceHourLimit
                )
            );

            const rowStateForSave = expectedStateForDayEdit;

            const updatePromises = dayEditRows
                .filter((r) => r.tsId)
                .filter((r) => r.locked !== true)
                .map((row) => {
                    const validated = validatedRows.find((v) => v.row === row);
                    return runPlanningOpWithForce(
                        (force) =>
                            updateTimeSlot(row.tsId, {
                                user_id: dayEditOwnerId,
                                hour_type_id: row.hourTypeId,
                                start_date: validated.startSeconds,
                                end_date: validated.endSeconds,
                                state: rowStateForSave,
                                force,
                            }),
                        canForceHourLimit
                    );
                });

            const createPromises = dayEditRows
                .filter((r) => !r.tsId)
                .filter((r) => r.locked !== true)
                .map((row) => {
                    const validated = validatedRows.find((v) => v.row === row);
                    return runPlanningOpWithForce(
                        (force) =>
                            createTimeSlot({
                                user_id: dayEditOwnerId,
                                hour_type_id: row.hourTypeId,
                                start_date: validated.startSeconds,
                                end_date: validated.endSeconds,
                                state: rowStateForSave,
                                force,
                            }),
                        canForceHourLimit
                    );
                });

            await Promise.all([...deletePromises, ...updatePromises, ...createPromises]);

            toast.success("Journée mise à jour.");
            await loadPlanning();

            setSelectedTimeSlots([]);
            setSelectedDates([]);
            setDayEditToDeleteIds([]);
            setDayEditRows([]);
            setDayEditModalOpen(false);
        } catch (e) {
            const data = e?.response?.data;
            if (!data?.violations?.length) {
                toast.error(
                    extractApiErrorMessage(
                        data,
                        "Une erreur est survenue lors de l'enregistrement."
                    )
                );
            }
        } finally {
            setIsSavingDayEdit(false);
        }
    };

    const selectedDayModel =
        selectedDayModelId && dayModels.length > 0
            ? dayModels.find((dm) => String(dm.id) === String(selectedDayModelId))
            : null;

    const selectedDayModelDetails =
        selectedDayModel?.day_model_details ??
        selectedDayModel?.dayModelDetails ??
        [];

    const applyDayModelNeedsValidation = useMemo(
        () => dayModelRequiresValidation(selectedDayModelDetails, hourTypesById),
        [selectedDayModelDetails, hourTypesById]
    );

    const handleApplyDayModel = async () => {
        try {
            if (!canOpenApplyDayModelModal) return;
            if (!selectedDayModelId) {
                toast.error("Veuillez choisir un modèle de journée.");
                return;
            }

            setIsApplyingDayModel(true);

            if (applyDayModelNeedsValidation) {
                if (!validationRemarks.trim()) {
                    toast.error("Veuillez renseigner un commentaire.");
                    setIsApplyingDayModel(false);
                    return;
                }

                const targets = buildApplyDayModelTargets({
                    selectedTimeSlotsDetails,
                    selectedUserIdFromSelectedId,
                    applyDayModelTargetDayKeys,
                    getTimeSlotOwnerId,
                    toDayKey,
                });

                if (targets.length === 0) {
                    toast.error("Aucune journée ciblée.");
                    setIsApplyingDayModel(false);
                    return;
                }

                const rows = buildCorrectionRowsFromDayModel(selectedDayModelDetails);
                const remarks = validationRemarks.trim();

                for (const target of targets) {
                    const resp = await askValidation({
                        hour_type_id: null,
                        day: target.day,
                        remarks,
                        rows,
                        user_id: parseInt(target.user_id, 10),
                    });
                    toast.success(resp.data?.message ?? "Demande de validation créée.");
                }

                await loadPlanning();
                setSelectedTimeSlots([]);
                setSelectedDates([]);
                setValidationRemarks("");
                setApplyDayModelModalOpen(false);
                setIsApplyingDayModel(false);
                return;
            }

            const payload = {
                day_model_id: parseInt(selectedDayModelId, 10),
            };

            if (selectedTimeSlotsDetails.length > 0) {
                payload.time_slot_ids = selectedTimeSlotsDetails.map((ts) => ts.id);
            } else {
                payload.user_id = parseInt(selectedUserIdFromSelectedId, 10);
                payload.days = applyDayModelTargetDayKeys;
            }

            await runPlanningOpWithForce(
                (force) => applyDayModelToTimeSlots({ ...payload, force }),
                canForceHourLimit
            );

            toast.success("Modèle appliqué.");
            await loadPlanning();

            setSelectedTimeSlots([]);
            setSelectedDates([]);
            setApplyDayModelModalOpen(false);
        } catch (e) {
            const data = e?.response?.data;
            if (!data?.violations?.length) {
                toast.error(
                    extractApiErrorMessage(
                        data,
                        "Une erreur est survenue lors de l'application du modèle."
                    )
                );
            }
        } finally {
            setIsApplyingDayModel(false);
        }
    };

    const applyDayModelModalContent = (
        <div className="space-y-4">
            <div className="text-sm text-gray-600">
                {applyDayModelTargetDayKeys.length === 0 ? (
                    "Aucune journée ciblée."
                ) : (
                    <>
                        <div className="font-medium text-gray-900">Jours ciblés</div>
                        <div className="mt-1 text-gray-700 wrap-break-word">
                            {applyDayModelTargetDayKeys
                                .slice(0, 20)
                                .map((k) => formatDayKeyShort(k))
                                .join(" • ")}
                            {applyDayModelTargetDayKeys.length > 20 ? " …" : ""}
                        </div>
                    </>
                )}
            </div>

            <div className="w-full">
                <DefaultDropdown
                    name={"Modèle de journée"}
                    options={dayModels.map((dm) => ({ label: dm.name, value: String(dm.id) }))}
                    value={selectedDayModelId}
                    onChange={(e) => setSelectedDayModelId(e.target.value)}
                />
            </div>

            <div className="rounded-md border border-gray-200 p-3">
                <div className="font-semibold text-gray-900">Aperçu</div>
                {selectedDayModelDetails.length === 0 ? (
                    <div className="mt-2 text-sm text-gray-500">Aucune tranche.</div>
                ) : (
                    <div className="mt-2 space-y-2">
                        {selectedDayModelDetails.map((d, idx) => (
                            <div key={d.id ?? idx} className="flex items-center justify-between gap-3 text-sm">
                                <div className="text-gray-900">
                                    {String(d.start_time ?? "").slice(0, 5)} → {String(d.end_time ?? "").slice(0, 5)}
                                </div>
                                <div className="text-gray-600">
                                    {d.hour_type?.name ?? d.hourType?.name ?? `#${d.hour_type_id}`}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {renderValidationRemarksField(applyDayModelNeedsValidation)}

            <div className="flex items-center justify-end gap-2">
                <Button
                    isVisible={canEditPlanning()}
                    type={!canOpenApplyDayModelModal ? "disabled" : "empty"}
                    name="Appliquer"
                    loading={isApplyingDayModel}
                    action={() => {
                        if (!canOpenApplyDayModelModal || isApplyingDayModel) return;
                        handleApplyDayModel();
                    }}
                />
                <Button
                    type="empty"
                    name="Annuler"
                    action={() => setApplyDayModelModalOpen(false)}
                />
            </div>
        </div>
    );

    const dayEditModalContent = (
        <div className="space-y-6">
            <div className="space-y-2">
                <div className="text-lg font-semibold text-gray-900">
                    {dayEditDayKey ? parseDayKeyToDate(dayEditDayKey)?.toLocaleDateString("fr-FR") : "Journée"}
                </div>
                <div className="text-sm text-gray-600">
                    {dayEditOwnerId && String(dayEditOwnerId) === String(user.id)
                        ? "Édition de votre journée"
                        : "Édition d'une journée"}
                </div>
            </div>

            <div className="space-y-3">
                {dayEditRows.length === 0 ? (
                    <div className="text-sm text-gray-500">Aucun créneau sur la journée.</div>
                ) : (
                    <>
                        {dayEditRows.map((row, index) => (
                            <div key={row.tsId ?? `new-${index}`} className="py-1 first:pt-0 last:pb-0">
                                <HourSlice
                                    index={index}
                                    nameStartTime={"Début"}
                                    nameEndTime={"Fin"}
                                    nameHourType={"Type d'heure"}
                                    listHourTypes={hoursTypes}
                                    valueStartTime={row.startTime}
                                    valueEndTime={row.endTime}
                                    valueHourType={row.hourTypeId}
                                    setStartTime={setDayEditStartTime}
                                    setEndTime={setDayEditEndTime}
                                    setHourType={setDayEditHourType}
                                    onRemove={handleRemoveDayEditRow}
                                    disabled={row.locked === true}
                                    classNameWrapper="mb-0"
                                />
                            </div>
                        ))}
                    </>
                )}
            </div>

            {renderValidationRemarksField(dayEditNeedsValidation)}

            <div className="flex items-center justify-between gap-3">
                <Button
                    isVisible={canEditPlanning()}
                    type="empty"
                    name="Ajouter un créneau"
                    action={() => {
                        addDayEditRow();
                    }}
                />

                <div className="flex items-center gap-2">
                    <Button
                        isVisible={canEditPlanning()}
                        name="Enregistrer"
                        action={handleSaveDayEdit}
                        loading={isSavingDayEdit}
                    />
                    <Button
                        type="empty"
                        name="Annuler"
                        action={() => setDayEditModalOpen(false)}
                    />
                </div>
            </div>
        </div>
    );

    const datePicker = () => {

        if (isTeamPlanning) {
            return (
                <div className="grid grid-cols-2 gap-2 sm:flex-row sm:items-end sm:gap-2 w-full">
                    <div className="w-full min-w-0 sm:flex-1">
                        <DefaultDropdown
                            name={"Mois"}
                            options={dropdownMonths}
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                        />
                    </div>
                    <div className="w-full sm:w-32 shrink-0">
                        <InputForm
                            name={"Année"}
                            id={"planning_year"}
                            type={"number"}
                            min={2025}
                            max={2026}
                            value={year}
                            set={setYear}
                            className={
                                "appearance-none block w-full bg-gray-200 text-app-primary border rounded-sm py-2 px-3 leading-tight focus:outline-hidden focus:bg-white"
                            }
                            classNameWrapper={"w-full"}
                        />
                    </div>
                </div>
            );
        }

        switch (view) {
            case "weekly":
                return (
                    <div className="grid grid-cols-2 gap-2 sm:flex-row sm:items-end sm:gap-2 w-full">
                        <div className="w-full min-w-0 sm:flex-1">
                            <InputForm
                                name={"Début"}
                                id={"start_date_planning"}
                                type={"date"}
                                // min="2025-01-01"
                                // max="2026-12-31"
                                value={startDatePlanning}
                                set={setStartDatePlanning}
                                className={
                                    "appearance-none block w-full bg-gray-200 text-app-primary border rounded-sm py-2 px-3 leading-tight focus:outline-hidden focus:bg-white"
                                }
                            />
                        </div>
                        <div className="w-full min-w-0 sm:flex-1">
                            <InputForm
                                name={"Fin"}
                                id={"end_date_planning"}
                                // min="2025-01-01"
                                // max="2026-12-31"
                                type={"date"}
                                value={endDatePlanning}
                                set={setEndDatePlanning}
                                className={
                                    "appearance-none block w-full bg-gray-200 text-app-primary border rounded-sm py-2 px-3 leading-tight focus:outline-hidden focus:bg-white"
                                }
                            />
                        </div>
                    </div>
                );
            case "monthly":
                return (
                    <div className="grid grid-cols-2 gap-2 sm:flex-row sm:items-end sm:gap-2 w-full">
                        <div className="w-full min-w-0 sm:flex-1">
                            <DefaultDropdown
                                name={"Mois"}
                                options={dropdownMonths}
                                value={month}
                                onChange={(e) => setMonth(e.target.value)}
                            />
                        </div>
                        <div className="w-full sm:w-32 shrink-0">
                            <InputForm
                                name={"Année"}
                                id={"planning_year"}
                                type={"number"}
                                // min={2025}
                                // max={2026}
                                value={year}
                                set={setYear}
                                className={
                                    "appearance-none block w-full bg-gray-200 text-app-primary border rounded-sm py-2 px-3 leading-tight focus:outline-hidden focus:bg-white"
                                }
                                classNameWrapper={"w-full"}
                            />
                        </div>
                    </div>
                );
            case "annual":
                return (
                    <div className="w-full sm:w-32">
                        <InputForm
                            name={"Année"}
                            id={"planning_year"}
                            type={"number"}
                            // min={2025}
                            // max={2026}
                            value={year}
                            set={setYear}
                            className={
                                "appearance-none block w-full bg-gray-200 text-app-primary border rounded-sm py-2 px-3 leading-tight focus:outline-hidden focus:bg-white"
                            }
                            classNameWrapper={"w-full"}
                        />
                    </div>
                );
        }
    };

    const menu = (
        <div className="flex flex-col gap-3 min-w-0 w-full sm:flex-row sm:flex-wrap sm:items-end sm:gap-3 md:gap-4 pb-0.5">
            <div className="w-full min-w-0 sm:max-w-md sm:grow sm:basis-0">
                <DefaultDropdown
                    name={"Utilisateur"}
                    options={comboValues}
                    value={selectedId}
                    onChange={(e) => setselectedId(e.target.value)}
                />
            </div>
            {!isTeamPlanning && (
                <div className="w-full sm:w-44 md:w-48 sm:shrink-0">
                    <DefaultDropdown
                        name={"Affichage"}
                        options={dropdownAffichages}
                        value={view}
                        onChange={(e) => setView(e.target.value)}
                    />
                </div>
            )}
            <div className="w-full sm:w-auto sm:shrink-0 sm:flex sm:items-end">
                {datePicker()}
            </div>
        </div>
    );

    // const showSelectionPanel =
    //     canEditPlanning() || canViewSelectionDetails() || selectedTimeSlotsDetails.length > 0;

    const selectionSidebarPanelHeader = canEditPlanning() ? (
        <div className="space-y-3 p-4 border-b border-gray-200">
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <div className="text-sm font-semibold text-gray-900">Sélection</div>
                    <div className="text-xs text-gray-600 truncate">
                        {selectedTimeSlotsDetails.length > 0 ? selectionCountLabel : "Aucun créneau sélectionné"}
                    </div>
                </div>
                <div className="shrink-0 self-center flex gap-2">
                    <Button
                        isVisible={selectedTimeSlotsDetails.length > 0}
                        type={selectedTimeSlotsDetails.length > 0 ? "empty" : "disabled"}
                        name={"Vider"}
                        title={"Retirer tous les créneaux de la sélection"}
                        action={() => {
                            if (selectedTimeSlotsDetails.length === 0) return;
                            setSelectedTimeSlots([]);
                        }}
                    />
                    <Button
                        isVisible={canViewSelectionDetails()}
                        type={canViewSelectionDetails() ? "empty" : "disabled"}
                        name={"Détail"}
                        title={canViewSelectionDetails() ? "Voir le détail" : "Droit insuffisant pour au moins un créneau sélectionné"}
                        action={() => {
                            if (!canViewSelectionDetails()) return;
                            setDetailsModalOpen(true);
                        }}
                    />
                </div>
            </div>

            <div className="flex flex-col gap-2 w-full [&_button]:block [&_button]:w-full [&_button]:whitespace-normal! [&_button]:text-left [&_button]:h-auto [&_button]:min-h-12 [&_button]:py-2.5">
                <Button
                    isVisible={canEditPlanning()}
                    type={canEditSelection() ? "empty" : "disabled"}
                    name={"Changer en..."}
                    title={canEditSelection() ? "Changer en..." : "Droit insuffisant pour au moins un créneau sélectionné"}
                    action={() => {
                        if (!canEditSelection()) return;
                        setEditModalOpen(true);
                    }}
                />

                <Button
                    isVisible={canEditPlanning()}
                    type={canOpenDayEditModal() ? "empty" : "disabled"}
                    name={canOpenDayEditModal() && dayEditDayKey ? `Modifier le ${formatDayKeyLong(dayEditDayKey)}` : "Modifier la journée"}
                    title={canOpenDayEditModal() ? "Modifier les créneaux de la journée" : "Sélectionnez une seule journée (et un seul utilisateur) pour éditer"}
                    action={() => {
                        if (!canOpenDayEditModal()) return;

                        setDayEditToDeleteIds([]);
                        setDayEditRows(
                            dayEditTimeSlots.map((ts) => {
                                const start = new Date(ts.start_date);
                                const end = new Date(ts.end_date);
                                const hhmm = (d) =>
                                    `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
                                const rowState = expectedPlanningStateForDayKey(
                                    getLastDatePlanningRealForUser(dayEditOwnerId),
                                    dayEditDayKey
                                );
                                const locked = rowState === "REAL" && !canEditReal;

                                return {
                                    tsId: ts.id,
                                    userId: getTimeSlotOwnerId(ts),
                                    hourTypeId: ts.hour_type_id ?? ts.hour_type?.id,
                                    startTime: hhmm(start),
                                    endTime: hhmm(end),
                                    state: rowState,
                                    locked,
                                };
                            })
                        );
                        setDayEditModalOpen(true);
                    }}
                />

                <Button
                    isVisible={canEditPlanning()}
                    type={canOpenApplyDayModelModal ? "empty" : "disabled"}
                    name={"Appliquer un modèle"}
                    title={canOpenApplyDayModelModal ? "Appliquer un modèle de journée" : "Sélectionnez des créneaux (ou une/plusieurs dates en individuel) et vérifiez vos droits"}
                    action={() => openApplyDayModelModal()}
                />

            </div>
        </div>
    ) : null;

    const render = () => {
        if (isLoading) {
            return (
                <div className="flex items-center justify-center py-20">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary mx-auto mb-4"></div>
                        <p className="text-gray-600 font-medium">Chargement du planning...</p>
                    </div>
                </div>
            );
        }

        if (!isTeamPlanning && view === "weekly") {
            return (
                <WeeklyUserPlanning
                    key="wup"
                    startDate={startDate}
                    endDate={endDate}
                    planning={planning}
                    badgeages={badgeages}
                    onClickDate={handleClickDate}
                    onClickTimeSlots={handleClickTimeSlots}
                    onClickWeek={handleClickWeek}
                    selectedTimeSlots={selectedTimeSlots}
                    selectedDates={selectedDates}
                    publicHolidays={holidays}
                />
            );
        }

        if (!isTeamPlanning && view === "monthly") {
            return (
                <MonthlyUserPlanning
                    key="mup"
                    startDate={startDate}
                    endDate={endDate}
                    planning={planning}
                    onClickDate={handleClickDate}
                    onClickTimeSlots={handleClickTimeSlots}
                    selectedTimeSlots={selectedTimeSlots}
                    publicHolidays={holidays}
                />
            );
        }

        if (!isTeamPlanning && view === "annual") {
            return (
                <AnnualUserPlanning
                    key="aup"
                    startDate={startDate}
                    endDate={endDate}
                    planning={planning}
                    onClickDate={handleClickDate}
                    onClickTimeSlots={handleClickTimeSlots}
                    selectedTimeSlots={selectedTimeSlots}
                    publicHolidays={holidays}
                />
            );
        }

        if (isTeamPlanning) {
            const handleNavigateTeamMonth = (delta) => {
                const currentMonth = Number.parseInt(month, 10);
                const currentYear = Number.parseInt(year, 10);
                if (!Number.isFinite(currentMonth) || !Number.isFinite(currentYear)) return;

                const next = new Date(currentYear, currentMonth - 1 + delta, 1);
                setMonth(next.getMonth() + 1);
                setYear(next.getFullYear());
            };

            return (
                <MonthlyTeamPlanning
                    key="mtp"
                    startDate={startDate}
                    endDate={endDate}
                    planning={planning}
                    users={teamUsers}
                    headcountByDayKey={teamHeadcountByDayKey}
                    onNavigateMonth={handleNavigateTeamMonth}
                    onClickDate={handleClickDate}
                    onClickTimeSlots={handleClickTimeSlots}
                    selectedTimeSlots={selectedTimeSlots}
                    publicHolidays={holidays}
                />
            );
        }


    };

    return (
        <div className="min-h-full bg-gray-50">
            {/* Titre (défile avec la page) */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-6">
                    <h1 className="text-3xl font-bold text-gray-900 inline-block">
                        Planning
                    </h1>
                    <p className="mt-2 text-sm text-gray-600">
                        Consultez et gérez votre planning individuel ou d'équipe
                    </p>
                </div>
            </div>

            {/* Barre filtres + actions (sticky uniquement) */}
            <div className="sticky top-0 z-20 bg-white border-b border-gray-200 shadow-sm overflow-visible print:static print:z-auto">
                <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-4 overflow-visible">
                    <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between lg:gap-4 xl:gap-6">
                        <div className="min-w-0 w-full lg:flex-1 lg:min-w-0">
                            {menu}
                        </div>
                        <div className="flex flex-wrap items-stretch sm:items-center gap-2 w-full lg:w-auto lg:shrink-0 justify-start sm:justify-end overflow-visible">
                            {canSeePlanningActionsMenu ? (
                                <div className="relative" ref={planningActionsMenuRef}>
                                    <button
                                        type="button"
                                        className={`inline-flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-800 shadow-xs hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-app-primary focus:ring-offset-2 ${planningActionsMenuOpen ? "ring-2 ring-app-primary ring-offset-2" : ""}`}
                                        title="Actions"
                                        onClick={() =>
                                            setPlanningActionsMenuOpen((v) => {
                                                const next = !v;
                                                if (next) setPlanningInfoPanelOpen(false);
                                                return next;
                                            })
                                        }
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4" aria-hidden="true">
                                            <path d="M12 12h.01" />
                                            <path d="M19 12h.01" />
                                            <path d="M5 12h.01" />
                                        </svg>
                                        <span>Actions</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`h-4 w-4 transition-transform ${planningActionsMenuOpen ? "rotate-180" : ""}`} aria-hidden="true">
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </button>

                                    {planningActionsMenuOpen ? (
                                        <div
                                            className="sm:hidden fixed inset-0 z-55 bg-black/25"
                                            aria-hidden
                                            onMouseDown={() => setPlanningActionsMenuOpen(false)}
                                        />
                                    ) : null}

                                    {planningActionsMenuOpen ? (
                                        <div
                                            className="z-60 max-h-[min(75dvh,calc(100dvh-9rem))] overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl
                                            fixed inset-x-3 top-[calc(env(safe-area-inset-top,0px)+8.25rem)] w-auto
                                            sm:absolute sm:inset-x-auto sm:left-auto sm:right-0 sm:top-full sm:mt-2 sm:max-h-[min(28rem,calc(100vh-12rem))] sm:w-80 sm:min-w-[20rem]"
                                        >
                                            <div className="px-3 py-2 border-b border-gray-100">
                                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Sélection</div>
                                            </div>

                                            <div className="py-1">
                                                <button
                                                    type="button"
                                                    disabled={!canEditSelection()}
                                                    className={`w-full flex items-start gap-3 px-3 py-2.5 text-left ${canEditSelection() ? "text-gray-800 hover:bg-gray-50" : "text-gray-400 cursor-not-allowed"}`}
                                                    title={canEditSelection() ? "Changer le type d'heure des créneaux sélectionnés" : "Sélectionnez des créneaux et vérifiez vos droits"}
                                                    onClick={() => {
                                                        if (!canEditSelection()) return;
                                                        setPlanningActionsMenuOpen(false);
                                                        setEditModalOpen(true);
                                                    }}
                                                >
                                                    <span className="mt-0.5 h-5 w-5 shrink-0">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" aria-hidden="true">
                                                            <path d="M12 20h9" />
                                                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                                                        </svg>
                                                    </span>
                                                    <span className="min-w-0">
                                                        <div className="text-sm font-medium">Changer en…</div>
                                                        <div className="text-xs text-gray-500">Modifier le type d’heure des créneaux sélectionnés</div>
                                                    </span>
                                                </button>

                                                <button
                                                    type="button"
                                                    disabled={!canOpenDayEditModal()}
                                                    className={`w-full flex items-start gap-3 px-3 py-2.5 text-left ${canOpenDayEditModal() ? "text-gray-800 hover:bg-gray-50" : "text-gray-400 cursor-not-allowed"}`}
                                                    title={canOpenDayEditModal() ? "Modifier les créneaux de la journée" : "Sélectionnez une seule journée (et un seul utilisateur) pour éditer"}
                                                    onClick={() => {
                                                        if (!canOpenDayEditModal()) return;
                                                        setPlanningActionsMenuOpen(false);

                                                        setDayEditToDeleteIds([]);
                                                        setDayEditRows(
                                                            dayEditTimeSlots.map((ts) => {
                                                                const start = new Date(ts.start_date);
                                                                const end = new Date(ts.end_date);
                                                                const hhmm = (d) =>
                                                                    `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
                                                                const rowState = expectedPlanningStateForDayKey(
                                                                    getLastDatePlanningRealForUser(dayEditOwnerId),
                                                                    dayEditDayKey
                                                                );
                                                                const locked = rowState === "REAL" && !canEditReal;

                                                                return {
                                                                    tsId: ts.id,
                                                                    userId: getTimeSlotOwnerId(ts),
                                                                    hourTypeId: ts.hour_type_id ?? ts.hour_type?.id,
                                                                    startTime: hhmm(start),
                                                                    endTime: hhmm(end),
                                                                    state: rowState,
                                                                    locked,
                                                                };
                                                            })
                                                        );
                                                        setDayEditModalOpen(true);
                                                    }}
                                                >
                                                    <span className="mt-0.5 h-5 w-5 shrink-0">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" aria-hidden="true">
                                                            <path d="M8 6h13" />
                                                            <path d="M8 12h13" />
                                                            <path d="M8 18h13" />
                                                            <path d="M3 6h.01" />
                                                            <path d="M3 12h.01" />
                                                            <path d="M3 18h.01" />
                                                        </svg>
                                                    </span>
                                                    <span className="min-w-0">
                                                        <div className="text-sm font-medium">
                                                            {canOpenDayEditModal() && dayEditDayKey ? `Modifier le ${formatDayKeyLong(dayEditDayKey)}` : "Modifier la journée"}
                                                        </div>
                                                        <div className="text-xs text-gray-500">Éditer une journée (créneaux + horaires)</div>
                                                    </span>
                                                </button>

                                                <button
                                                    type="button"
                                                    disabled={!canOpenApplyDayModelModal}
                                                    className={`w-full flex items-start gap-3 px-3 py-2.5 text-left ${canOpenApplyDayModelModal ? "text-gray-800 hover:bg-gray-50" : "text-gray-400 cursor-not-allowed"}`}
                                                    title={canOpenApplyDayModelModal ? "Appliquer un modèle de journée" : "Sélectionnez des créneaux (ou une/plusieurs dates en individuel) et vérifiez vos droits"}
                                                    onClick={() => {
                                                        if (!canOpenApplyDayModelModal) return;
                                                        setPlanningActionsMenuOpen(false);
                                                        openApplyDayModelModal();
                                                    }}
                                                >
                                                    <span className="mt-0.5 h-5 w-5 shrink-0">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" aria-hidden="true">
                                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                            <path d="M7 10l5 5 5-5" />
                                                            <path d="M12 15V3" />
                                                        </svg>
                                                    </span>
                                                    <span className="min-w-0">
                                                        <div className="text-sm font-medium">Appliquer un modèle</div>
                                                        <div className="text-xs text-gray-500">Appliquer un modèle de journée à la sélection</div>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}

                            {!isTeamPlanning ? (
                                <div className="relative print:hidden" ref={planningInfoPanelRef}>
                                    {planningInfoPanelOpen ? (
                                        <div
                                            className="sm:hidden fixed inset-0 z-55 bg-black/25"
                                            aria-hidden
                                            onMouseDown={() => setPlanningInfoPanelOpen(false)}
                                        />
                                    ) : null}

                                    {planningInfoPanelOpen ? (
                                        <div
                                            className="z-60 max-h-[min(75dvh,calc(100dvh-9rem))] overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl
                                            fixed inset-x-3 top-[calc(env(safe-area-inset-top,0px)+8.25rem)] w-auto
                                            sm:absolute sm:inset-x-auto sm:left-auto sm:right-0 sm:top-full sm:mt-2 sm:max-h-[min(28rem,calc(100vh-12rem))] sm:w-[min(26rem,calc(100vw-2rem))] sm:min-w-[20rem]"
                                        >
                                            <div className="p-3 border-b border-gray-200 flex items-start justify-between gap-3">
                                                <div className="min-w-0">
                                                    <div className="text-sm font-semibold text-gray-900">Synthèse</div>
                                                    <div className="text-xs text-gray-600 truncate">{selectedLabel || "Planning"}</div>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="shrink-0 text-gray-500 hover:text-gray-700"
                                                    onClick={() => setPlanningInfoPanelOpen(false)}
                                                    title="Fermer"
                                                >
                                                    <span className="sr-only">Fermer</span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" aria-hidden="true">
                                                        <path d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </div>

                                            <div className="p-3 space-y-6">
                                                {renderMergedHourTypeSummary()}
                                                {selectedUserIdFromSelectedId ? renderUserCountersSidebar() : null}
                                            </div>
                                        </div>
                                    ) : null}

                                    <button
                                        type="button"
                                        className={`inline-flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-800 shadow-xs hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-app-primary focus:ring-offset-2 ${planningInfoPanelOpen ? "ring-2 ring-app-primary ring-offset-2" : ""}`}
                                        onClick={() =>
                                            setPlanningInfoPanelOpen((v) => {
                                                const next = !v;
                                                if (next) setPlanningActionsMenuOpen(false);
                                                return next;
                                            })
                                        }
                                        title={planningInfoPanelOpen ? "Masquer la synthèse" : "Afficher la synthèse et les compteurs"}
                                    >
                                        <span>Synthèse</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className={`h-4 w-4 transition-transform ${planningInfoPanelOpen ? "rotate-180" : ""}`}
                                            aria-hidden="true"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </button>
                                </div>
                            ) : null}

                            <Button
                                type="empty"
                                name={
                                    <>
                                        <span className="sr-only">Imprimer</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        >
                                            <path d="M6 9V2h12v7" />
                                            <path d="M6 18H4a2 2 0 0 1-2-2v-5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v5a2 2 0 0 1-2 2h-2" />
                                            <path d="M6 14h12v8H6z" />
                                        </svg>
                                    </>
                                }
                                title={"Imprimer le planning affiché"}
                                action={() => window.print()}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="flex flex-col lg:flex-row gap-6">
                    {/* Panneau de droite (responsive) */}
                    {null}

                    <div className="order-2 lg:order-1 flex-1 min-w-0">
                        {/* Contenu du planning */}
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">

                            <div className={`printable ${printableFitClass}`}>
                                <div className="print-only mb-4">
                                    <div className="text-xl font-bold text-gray-900">
                                        {selectedLabel || "Planning"}
                                    </div>
                                    {printPeriodLabel ? (
                                        <div className="text-sm text-gray-700 mt-1">
                                            {printPeriodLabel}
                                        </div>
                                    ) : null}
                                    {!isTeamPlanning ? (
                                        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
                                            <div className="rounded-md border border-gray-200 bg-white p-3">
                                                {renderMergedHourTypeSummaryPrint()}
                                            </div>
                                            <div className="rounded-md border border-gray-200 bg-white p-3">
                                                {renderUserCountersPrint()}
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                {render()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SideBar
                title={"Changer en..."}
                content={editModalContent}
                isOpen={editModalOpen}
                isModal={true}
                onClose={() => setEditModalOpen(false)}
            />

            <SideBar
                title={"Détails des créneaux sélectionnés"}
                content={detailsModalContent}
                isOpen={detailsModalOpen}
                isModal={true}
                onClose={() => setDetailsModalOpen(false)}
            />

            <SideBar
                title={"Détail prévu / réalisé par type d'heure"}
                content={hourTypeSummaryModalContent}
                isOpen={hourTypeSummaryModalOpen}
                isModal={true}
                onClose={() => setHourTypeSummaryModalOpen(false)}
            />

            <SideBar
                title={"Modifier la journée"}
                content={dayEditModalContent}
                isOpen={dayEditModalOpen}
                isModal={true}
                onClose={() => {
                    setDayEditModalOpen(false);
                    setDayEditRows([]);
                    setDayEditToDeleteIds([]);
                }}
            />

            <SideBar
                title={"Appliquer un modèle de journée"}
                content={applyDayModelModalContent}
                isOpen={applyDayModelModalOpen}
                isModal={true}
                onClose={() => setApplyDayModelModalOpen(false)}
            />
        </div>
    );
};

export default IndividualPlanning;
